import { faBadgeDollar, faBuilding, faCube, faLocationDot, faScaleUnbalanced } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropertyInfoRow from './property_info_row';

type Props = {
  hasActiveProduct: boolean;
  property: any;
}

const ICON_MAP: { [key: string]: any } = {
  'fa-building': faBuilding,
  'fa-badge-dollar': faBadgeDollar,
  'fa-location-dot': faLocationDot,
  'fa-cube': faCube,
  'fa-scale-unbalanced': faScaleUnbalanced,
};

function humanize(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // insert space before capitals
    .replace(/^./, char => char.toUpperCase()); // capitalize first letter
}

export default function PropertyInfoDetails({ hasActiveProduct, property }: Props) {

  return (
    <div className="d-flex flex-column gap-6">
      {Object.keys(property.summary).map(key => (
        <React.Fragment key={key}>
          {property.summary[key].fields.length > 0 && (
            <div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon
                  className="text-secondary"
                  icon={ICON_MAP[property.summary[key].icon]}
                />
                <h6 className="my-0 fw-bolder">{humanize(key)}</h6>
              </div>
              {property.summary[key].fields.map((field, i) => (
                <PropertyInfoRow
                  hasActiveProduct={hasActiveProduct}
                  key={i}
                  label={field.label}
                  restricted={!!field.restricted}
                  value={field.value}
                />
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
